import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

function Copyright() {
  return (
    <Typography sx={{ fontSize: 14, color: "#aaaaaa", fontFamily: "Poppins", }}>
      {"Copyright © ACASA-BISA, 2025. All rights reserved."}
      {/* <Link color="inherit" href="https://mui.com/">
        Your Website
      </Link> {' '}*/}
    </Typography>
  );
}

const logoStyle = {
  width: "auto",
  height: "13vh",
  padding: "5px",
};

export default function StickyFooter() {
  return (
    <Box
      sx={{
        display: { xs: "flex", md: "flex" },
        flexDirection: "column",
        fontFamily: "Poppins",
        textAlign: { sm: "center", md: "left" },
      }}
    >
      <Box
        component="footer"
        sx={{
          position: "sticky",
          py: 3,
          px: 2,
          mt: 0,
          backgroundColor: "#111111",
          fontFamily: "Poppins",
        }}
      >
        <Box sx={{ width: { xs: "100%", sm: "100%" }, mb: 2 }}>
          <Box
            sx={{
              minHeight: "20vh",
              display: "flex",
              flexDirection: { xs: "column", md: "row" }, // ✅ stack on mobile
              alignItems: { xs: "center", md: "flex-start" },
              gap: 2,
              m: { xs: 2, md: 6 },
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/acasa-white.svg`}
              style={{
                height: "13vh",
                maxWidth: "100%",
              }}
              alt="logo of acasa"
              loading="lazy"
            />

            <Divider
              orientation="vertical"
              flexItem
              sx={{
                display: { xs: "none", md: "block" }, // ✅ hide divider on mobile
                bgcolor: "#555555",
                borderRightWidth: 2,
              }}
            />

            <Box sx={{ width: "100%", textAlign: { xs: "center", md: "left" } }}>
              <Typography
                sx={{
                  color: "#ffffff",
                  fontSize: { xs: "16px", md: "18px" },
                  fontFamily: "Poppins",
                }}
              >
                To address the vulnerability of South Asian countries to climatic risks,
                the Borlaug Institute for South Asia (BISA) with support from Gates
                Foundation is working with national agriculture research systems of the
                region to develop ACASA.
              </Typography>

              <Button
                href="/acasa/#/about"
                sx={{
                  mt: 1,
                  color: "#fece2f",
                  backgroundColor: "transparent",
                  fontWeight: "bold",
                  "&:hover": { backgroundColor: "transparent" },
                }}
              >
                Read More
              </Button>
            </Box>
          </Box>

          <Divider
            sx={{
              bgcolor: "#252525",
              borderBottomWidth: 2,
              marginLeft: 6,
              marginRight: 6,
              fontFamily: "Poppins",
            }}
          />
        </Box>
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          {/*<Box sx={{ width: { xs: "100%", sm: "40%" }, margin: 6 }}>
            <Typography variant="h5" fontWeight={600} gutterBottom sx={{ color: "#ffffff", fontFamily: "Poppins", }}>
              Newsletter
            </Typography>
            <Typography variant="subtitle1" sx={{ color: "#ffffff", fontFamily: "Poppins", fontSize:'16px'}} mb={2}>
              Subscribe for regular newsletter and stay upto date with our latest news and updates.
            </Typography>
            <Stack direction="row" spacing={1} useFlexGap>
              <TextField
                id="outlined-basic"
                hiddenLabel
                size="small"
                variant="filled"
                fullWidth
                aria-label="Enter your email address"
                placeholder="Your email address"
                inputProps={{
                  autocomplete: "off",
                  ariaLabel: "Enter your email address",
                }}
                sx={{
                  fontFamily: "Poppins",
                  backgroundColor: (theme) => (theme.palette.mode === "dark" ? "#2c2f33" : "#ffffff"),
                }}
              />
              <Button
                variant="contained"
                sx={{
                  "flexShrink": 0,
                  "fontFamily": "Poppins",
                  "backgroundColor": "#fece2f",
                  "&:hover": { backgroundColor: "#aaaaaa" },
                }}
              >
                Subscribe
              </Button>
            </Stack>
          </Box>*/}
          <Box sx={{
              display: "flex",
              flexWrap: "wrap",        // ✅ wrap on small screens
              justifyContent: "space-between",
              gap: 4,
              m: { xs: 2, md: 6 },
            }}>
            <Box sx={{ width: { xs: "100%", md: "45%" } }}>
              <Typography variant="h5" fontWeight={600} gutterBottom sx={{ color: "#ffffff", fontFamily: "Poppins", }}>
                Contact BARC
              </Typography>
              <Table size="small" aria-label="a dense table" padding="none">
                <TableBody>
                  <TableRow key="1" sx={{ "& td": { border: 0 } }}>
                    <TableCell align="left" sx={{ width: "70px" }}>
                      <Typography variant="subtitle1" sx={{ color: "#ffffff", fontFamily: "Poppins", }}>
                        Name:
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography variant="subtitle1" sx={{ color: "#ffffff", fontWeight: "600", fontFamily: "Poppins", }} ml={2}>
                        Hasan Md. Hamidur Rahman
                      </Typography>
                    </TableCell>
                  </TableRow>

                  <TableRow key="1" sx={{ "& td": { border: 0 } }}>
                    <TableCell align="left" sx={{ width: "70px" }}>
                      <Typography variant="subtitle1" sx={{ color: "#ffffff", fontFamily: "Poppins", }}>
                        Address:
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography variant="subtitle1" sx={{ color: "#ffffff", fontWeight: "600", fontFamily: "Poppins", }} ml={2}>
                        Bangladesh Agricultural Research Council (BARC)
                      </Typography>
                    </TableCell>
                  </TableRow>

                  <TableRow key="2" sx={{ "& td": { border: 0 } }}>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left">
                      <Typography variant="subtitle1" sx={{ color: "#ffffff", fontFamily: "Poppins", fontSize:'16px' }} ml={2}>
                        BARC Complex
                      </Typography>
                    </TableCell>
                  </TableRow>

                  <TableRow key="4" sx={{ "& td": { border: 0 } }}>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left">
                      <Typography variant="subtitle1" sx={{ color: "#ffffff", fontFamily: "Poppins", }} ml={2}>
                        Farmgate, Dhaka, Bangladesh
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              {/*<Divider
              sx={{
                bgcolor: "#252525",
                borderBottomWidth: 2,
                marginTop: 2,
                marginBottom: 2,
              }}
            />
            <Table size="small" aria-label="a dense table" padding="none">
              <TableBody>
                <TableRow key="1" sx={{ "& td": { border: 0 } }}>
                  <TableCell align="left" sx={{ width: "70px" }}>
                    <Typography variant="subtitle1" sx={{ color: "#ffffff" }}>
                      Phone:
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography variant="subtitle1" sx={{ color: "#ffffff" }} ml={2}>
                      +91-11-25842940
                    </Typography>
                  </TableCell>
                </TableRow>
                <TableRow key="2" sx={{ "& td": { border: 0 } }}>
                  <TableCell align="left"></TableCell>
                  <TableCell align="left">
                    <Typography variant="subtitle1" sx={{ color: "#ffffff" }} ml={2}>
                      +91-11-2584 2938
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>*/}
              <Divider
                sx={{
                  bgcolor: "#252525",
                  borderBottomWidth: 2,
                  marginTop: 2,
                  marginBottom: 2,
                  fontFamily: "Poppins",
                }}
              />
              <Table size="small" aria-label="a dense table" padding="none">
                <TableBody>
                  <TableRow key="1" sx={{ "& td": { border: 0 } }}>
                    <TableCell align="left" sx={{ width: "70px" }}>
                      <Typography variant="subtitle1" sx={{ color: "#ffffff", fontFamily: "Poppins", }}>
                        Email:
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography variant="subtitle1" sx={{ color: "#fece2f", fontFamily: "Poppins", }} ml={2}>
                        <Link color="inherit" href="mailto:h.rahman@barc.gov.bd">
                          h.rahman@barc.gov.bd
                        </Link>
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
            <Box sx={{ width: { xs: "100%", md: "45%" } }}>
              <Typography variant="h5" fontWeight={600} gutterBottom sx={{ color: "#ffffff", fontFamily: "Poppins", }}>
                Contact BISA
              </Typography>
              <Table size="small" aria-label="a dense table" padding="none">
                <TableBody>
                  <TableRow key="1" sx={{ "& td": { border: 0 } }}>
                    <TableCell align="left" sx={{ width: "70px" }}>
                      <Typography variant="subtitle1" sx={{ color: "#ffffff", fontFamily: "Poppins", }}>
                        Name:
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography variant="subtitle1" sx={{ color: "#ffffff", fontWeight: "600", fontFamily: "Poppins", }} ml={2}>
                        Dr Pramod Aggarwal
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow key="1" sx={{ "& td": { border: 0 } }}>
                    <TableCell align="left" sx={{ width: "70px", fontFamily: "Poppins", }}>
                      <Typography variant="subtitle1" sx={{ color: "#ffffff", fontFamily: "Poppins",}}>
                        Address:
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography variant="subtitle1" sx={{ color: "#ffffff", fontWeight: "600",fontFamily: "Poppins", }} ml={2}>
                        Borlaug Institute for South Asia (BISA)
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow key="2" sx={{ "& td": { border: 0 } }}>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left">
                      <Typography variant="subtitle1" sx={{ color: "#ffffff", fontFamily: "Poppins", }} ml={2}>
                        International Maize and Wheat Improvement Center
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow key="3" sx={{ "& td": { border: 0 } }}>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left">
                      <Typography variant="subtitle1" sx={{ color: "#ffffff", fontFamily: "Poppins", }} ml={2}>
                        CIMMYT, CG Block B, NASC, DPS Marg, Pusa,
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow key="4" sx={{ "& td": { border: 0 } }}>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left">
                      <Typography variant="subtitle1" sx={{ color: "#ffffff", fontFamily: "Poppins", }} ml={2}>
                        New Delhi - 110012, India
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <Divider
                sx={{
                  bgcolor: "#252525",
                  borderBottomWidth: 2,
                  marginTop: 2,
                  marginBottom: 2,
                  fontFamily: "Poppins",
                }}
              />
              <Table size="small" aria-label="a dense table" padding="none">
                <TableBody>
                  <TableRow key="1" sx={{ "& td": { border: 0 } }}>
                    <TableCell align="left" sx={{ width: "70px", fontFamily: "Poppins", }}>
                      <Typography variant="subtitle1" sx={{ color: "#ffffff", fontFamily: "Poppins", }}>
                        Phone:
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography variant="subtitle1" sx={{ color: "#ffffff", fontFamily: "Poppins", }} ml={2}>
                        +91-11-25842940
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow key="2" sx={{ "& td": { border: 0 } }}>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left">
                      <Typography variant="subtitle1" sx={{ color: "#ffffff", fontFamily: "Poppins", }} ml={2}>
                        +91-11-2584 2938
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
              <Divider
                sx={{
                  bgcolor: "#252525",
                  borderBottomWidth: 2,
                  marginTop: 2,
                  marginBottom: 2,
                  fontFamily: "Poppins",
                }}
              />
              <Table size="small" aria-label="a dense table" padding="none">
                <TableBody>
                  <TableRow key="1" sx={{ "& td": { border: 0 } }}>
                    <TableCell align="left" sx={{ width: "70px" }}>
                      <Typography variant="subtitle1" sx={{ color: "#ffffff", fontFamily: "Poppins", }}>
                        Email:
                      </Typography>
                    </TableCell>
                    <TableCell align="left">
                      <Typography variant="subtitle1" sx={{ color: "#fece2f", fontFamily: "Poppins", }} ml={2}>
                        <Link color="inherit" href="mailto:acasa@cgiar.org">
                          acasa@cgiar.org
                        </Link>
                      </Typography>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Box>
          </Box>
        </Box>
        <Divider
            sx={{
            bgcolor: "#252525",
            borderBottomWidth: 2,
            mt: { xs: 2, md: -4 },     // no negative margin on mobile
            mx: { xs: 2, md: 6 },      // smaller side margins on mobile
            fontFamily: "Poppins",
          }}
        />
        <Box
            sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",          // 🔑 allow wrap on mobile
            width: "100%",
            justifyContent: "center",
            fontFamily: "Poppins",
          }}
        >
          <Box
                sx={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",        // 🔑 prevent overflow
                gap: { xs: 1, md: 0 },   // spacing only on mobile
                m: 1,
                mt: 0,
                fontFamily: "Poppins",
                margin:{md:2}
              }}
          >
            
          </Box>
        </Box>
        <Box sx={{ textAlign: "center", py: 2 }}>
          <Copyright />
        </Box>
      </Box>
    </Box>
  );
}